/*eslint-disable*/ export const messages = { New: "新規", "Remove {label}": [["label"], " を削除"] };
